import { IconButton } from '@material-ui/core'
import { createStyles, withStyles } from '@material-ui/styles'

export const ActionIconButton = withStyles(() =>
  createStyles({
    root: {
      ['& span']: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  })
)(IconButton)
